import React, { useEffect, useState } from "react";
import { ActivityTracker } from "cai-fusion";
import { useNewTemplate } from "../../contexts/NewTemplateContext";

const ExecuteTemplateActivityTracker = ({}) => {
    const [isCollapsed, setIsCollapsed] = useState(false);
    const { executeText } = useNewTemplate();

    useEffect(() => {
        if (executeText === "") {
            setIsCollapsed(false);
        }
    }, [executeText])

    return (
        <ActivityTracker
            message={`${executeText}...`}
            isHidden={executeText === ""}
            isCollapsed={isCollapsed}
            onCollapse={(collapseState) => setIsCollapsed(collapseState)}
            hideProgressBar
        />
    )
}

export default ExecuteTemplateActivityTracker;